import React from 'react';

// Ordered low → high. `value` is sent to the worker as `quality`
// and maps directly to OpenAI's gpt-image-2 quality levels.
// Lower quality = faster (and cheaper) inference.
const LEVELS = [
  { value: 'low', label: 'Low', hint: '⚡ Fastest — draft quality' },
  { value: 'medium', label: 'Medium', hint: '⚖️ Balanced speed & detail' },
  { value: 'high', label: 'High', hint: '💎 Best quality — slowest' },
];

function QualitySlider({ quality, setQuality, disabled = false }) {
  const index = Math.max(0, LEVELS.findIndex((l) => l.value === quality));
  const active = LEVELS[index];

  return (
    <div className="quality-slider">
      <div className="quality-slider-head">
        <span className="quality-slider-label">Quality</span>
        <span className="quality-slider-value">{active.label}</span>
      </div>
      <input
        type="range"
        min={0}
        max={LEVELS.length - 1}
        step={1}
        value={index}
        disabled={disabled}
        onChange={(e) => setQuality(LEVELS[Number(e.target.value)].value)}
        className="quality-slider-input"
        aria-label="Generation quality"
        aria-valuetext={active.label}
      />
      <div className="quality-slider-ticks">
        {LEVELS.map((level) => (
          <button
            key={level.value}
            type="button"
            className={`quality-slider-tick ${level.value === quality ? 'active' : ''}`}
            onClick={() => setQuality(level.value)}
            disabled={disabled}
          >
            {level.label}
          </button>
        ))}
      </div>
      <span className="quality-slider-hint">{active.hint}</span>
    </div>
  );
}

export default QualitySlider;
